import { render, staticRenderFns } from "./InviteRow.vue?vue&type=template&id=2a31023c&scoped=true"
import script from "./InviteRow.vue?vue&type=script&lang=js"
export * from "./InviteRow.vue?vue&type=script&lang=js"
import style0 from "./InviteRow.vue?vue&type=style&index=0&id=2a31023c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a31023c",
  null
  
)

export default component.exports